import Colors from "../../../constants/Colors";

export default {
	pageName: "ViewJob",
	animationSize: 50,

	running: {
		amplitude: 30,
		frameRate: 30,
		speed: 2,
		strokeWidth: 4,
		color: Colors.green,
	},
};
